<div id="mainDiv">
  <app-header></app-header>
  <router-outlet (activate)="onActivate($event)" class="middel-contentDiv"></router-outlet>
  <app-footer></app-footer>
</div>